/**
 * Школа синтеза Форма заявки
 */
class ApplicationForm {
    constructor(form, settings, formLoader) {
        this.formTemplate = form.cloneNode(true);
        this.settings = settings;
        this.utms = {};
        this.form = form;
        formLoader.after(this.form);
        formLoader.remove();
        this.prepareForm();
    }

    prepareForm() {
        this.submitButton = this.form.querySelector('.form__element-submit');
        this.messageText = document.querySelector('.js-form-result');
        this.errorText = null;
        this.spinner = this.form.querySelector('.form__element-spinner');

        this.university = this.form.querySelector('[name="university"]');
        this.learningProgram = this.form.querySelector('[name="programma_obucheniya"]');
        this.format = this.form.querySelector('[name="forma_obucheniya"]');
        this.formatInPerson = this.format.querySelector('option[value="Очный"]');
        this.cluster = this.form.querySelector('[name="cluster"]');
        this.experience = this.form.querySelector('[name="experience"]');
        this.pdYadro = this.form.querySelector('[name="pd_yadro"]');

        this.unavailableClusters = Array.from(this.cluster.querySelectorAll('option[data-state="unavailable"]')).map((elem) => elem.value);
        this.prepare_smartcaptcha();
        this.formActions();
    }

    prepare_smartcaptcha()  {
        let self = this;
        const captchaContainer = this.form.querySelector('.captcha-container');
        this.captchaWidgetID = window.smartCaptcha.render(captchaContainer, {
            sitekey: self.settings.smartCaptchaClientKey,
            invisible: true,
            test: (typeof this.settings.isDebug !== 'undefined' && this.settings.isDebug === true),
            callback: (token) => {
                self.sendRequest(token);
                //console.info('Reset SC');
                //window.smartCaptcha.reset(captchaID);
            },
        });
    }

    formData() {
        let data = [];
        this.form.querySelectorAll('input, select, textarea').forEach((element) => {
            let value = element.value;
            if ('forma_obucheniya' === element.name) {
                data[element.getAttribute('name')] = value;
            } else if ('programma_obucheniya' === element.name) {
                data[element.getAttribute('name')] = value;
            } else {
                if (!element?.disabled) {
                    if (element.type == 'checkbox' && element.checked != true) {
                        value = 0;
                    }
                    data[element.getAttribute('name')] = value;
                }
            }
        });
        data['utms'] = this.getUtm();

        return data;
    }

    validateForm(markError = true) {
        let result = true;
        let errorElement = false;
        this.form.querySelectorAll('input:required, select:required, textarea:required').forEach((element) => {
            let validation = this.validate(element, markError);
            if (!validation) {
                result = false;
                if (!errorElement) {
                    errorElement = element;
                }
            }
        });

        if (!result && markError && errorElement) {
            errorElement.scrollIntoView({behavior: "smooth", block: "center"});
        }

        return result;
    }

    validate(element, markError = true) {
        let result = true;
        if (!this.validateInputLength(element, markError)) {
            result = false;
        } else {
            if (element.getAttribute('type') == 'email') {
                result = this.validateEmail(element, markError);
            } else if (element.getAttribute('type') == 'tel') {
                result = this.validatePhone(element, markError);
            } else if (element.classList.contains('form__input-cluster')) {
                result = this.validateClusterAvailability(element, markError);
            }
        }
        return result;
    }

    validateInputLength(input, markError = true) {
        let errorField = this.form.querySelector('[data-for="' + input.name + '"]');
        let result = true;
        if ((!input.value || (input.type == 'checkbox' && input.checked != true)) && !input.hasAttribute('disabled')) {
            if (errorField && markError) {
                errorField.textContent = 'Заполните это поле';
            }
            result = false;
        } else {
            if (errorField) {
                errorField.textContent = '';
            }
        }

        return result;
    }

    validateEmail(input, markError = true) {
        let inputValue = input.value;
        let errorField = this.form.querySelector('[data-for="' + input.name + '"]');
        let result = true;
        let pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!pattern.test(inputValue)) {
            if (errorField && markError) {
                errorField.textContent = 'Введите корректный email адрес';
            }
            result = false;
        } else {
            if (errorField) {
                errorField.textContent = '';
            }
        }

        return result;
    }

    validatePhone(input, markError = true) {
        let phone = input.value;
        let result = false;
        let length;
        if (phone.match(/\d/g)) {
            length = phone.match(/\d/g).length;
            if (length === 11 || length === 12) {
                result = true;
            }
        }

        let errorField = this.form.querySelector('[data-for="' + input.name + '"]');
        if (errorField) {
            if (!result && markError) {
                errorField.textContent = 'Введите корректный телефон';
                result = false;
            } else {
                errorField.textContent = '';
            }
        }
        return result;
    }

    validateClusterAvailability(clusterField, markError = true) {
        let errorField = this.form.querySelector('[data-for="' + clusterField.name + '"]');
        let result = true;

        Array.from(clusterField.selectedOptions).every((option) => {
            if (option.getAttribute('data-state') === 'unavailable') {
                result = false;
                return false;
            }
        });

        if (!result) {
            if (errorField && markError) {
                errorField.textContent = 'Приём заявок на данный кластер закрыт';
            }
        } else {
            if (errorField) {
                errorField.textContent = '';
            }
        }

        return result;
    }

    checkFormIsReady() {
        setTimeout(() => {
            if (this.validateForm(false)) {
                this.submitButton.classList.remove('disabled');
            } else {
                this.submitButton.classList.add('disabled');
            }
        }, 100);
    }

    formActions() {
        this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();

            if(!this.validateForm()) {
                return;
            }

            if (!window.smartCaptcha) {
                return;
            }

            window.smartCaptcha.execute(this.captchaWidgetID);
        });

        this.addListeners();
        this.addFirstActionListener();
    }

    getUtm() {
        if (new URLSearchParams(this.utms).toString() !== '') {
            return new URLSearchParams(this.utms).toString();
        }

        // let cookieName = 'chip_school_meta';
        //
        // let cookie = Cookies.get(cookieName);
        // if (cookie) {
        //     return cookie;
        // }

        let isUtms = 0;
        let queryString = window.location.search;
        let searchParams = new URLSearchParams(queryString);
        searchParams.forEach((value, key) => {
            if (key.indexOf('utm') === 0) {
                this.utms[key] = value;
                isUtms = 1;
            }
        });

        // if (isUtms) {
        //     let canSetCookie = 1;
        //     if (this.settings?.checkCookieConsent) {
        //         canSetCookie = Cookies.get('cookieconsent');
        //     }
        //
        //     if (canSetCookie) {
        //         Cookies.set(cookieName, new URLSearchParams(this.utms).toString(), {expires: 30});
        //     }
        // }

        return new URLSearchParams(this.utms).toString();
    }

    sendRequest(captchaId) {
        if (!this.validateForm()) {
            return;
        } else {
            this.spinner.style.display = 'block';
            this.submitButton.disabled = true;
            let data = this.formData();
            let encodedData = this.encodeParams(data);

            fetch(this.settings.sendRestUrl, {
                method: 'POST', headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                }, body: encodedData
            })
                .then(res => res.json())
                .then(response => {
                    try {
                        if (response?.data?.fields) {
                            response.data.fields.forEach((el) => {
                                this.form.querySelector('[data-for="' + el.name + '"]').textContent = el.message;
                            })
                        } else if (response?.status != 200) {
                            this.errorText = response?.message || 'Ошибка обработки формы';
                        }
                    } catch (e) {
                        this.errorText = 'Во время отправки произошла ошибка.';
                        // Обновление каптчи
                        if (typeof sgr_3 === 'function' && typeof grecaptcha !== 'undefined') {
                            sgr_3();
                        }
                    }
                })
                .catch(error => {
                    this.errorText = 'Отправка формы не удалась.';
                })
                .finally(() => {
                    if(window.smartCaptcha && this.captchaWidgetID !== undefined) {
                        window.smartCaptcha.reset(this.captchaWidgetID);
                    }
                })
                .then(() => {
                    document.body.classList.add('has-modal-open');

                    if (!this.errorText) {
                        this.messageText.innerHTML = this.settings?.templates.success || '';
                        const mailto = this.messageText.querySelector('.js-form-mailto');
                        if (mailto) {
                            mailto.innerHTML = `<span class="js-copy-to-clipboard copy__text">${this.settings?.contactEmail}</span>`;
                        }
                        window.YadroWebMetrics.track({
                            "event_category": "reg_form",
                            "event_action": "form_stage",
                            "event_label": "form_sent"
                        });
                    } else {
                        this.messageText.innerHTML = this.settings?.templates.error || '';
                        const fallback = this.messageText.querySelector('.js-form-description');
                        const fallbackAction = this.messageText.querySelector('.js-form-action');

                        if (fallback) {
                            fallback.innerHTML = `Отправить письмо на&nbsp;<span class="js-copy-to-clipboard copy__text">${this.settings?.contactEmail}</span>`;
                        }
                        if (fallbackAction) {
                            fallbackAction.innerHTML = `<a class="big-red-button --white" href="mailto:${this.settings?.contactEmail}">Отправить письмо</a>`;
                        }
                    }
                })
                .then(() => {
                    let copy = this.messageText.querySelector('.js-copy-to-clipboard') || '';
                    if (copy) {
                        copy.classList.add('--active');
                        copy.addEventListener('click', e => {
                            try {
                                let copyElement = document.createElement('textarea');

                                copyElement.textContent = copy.innerText;
                                copyElement.setAttribute('readonly', true);
                                copyElement.style.cssText = 'position:absolute;left:-9999px';
                                document.body.appendChild(copyElement);
                                copyElement.select();

                                const result = document.execCommand('copy')
                                if (result) {
                                    e.target.classList.add('--success');
                                    setTimeout(() => {
                                        e.target.classList.remove('--success');
                                    }, 500);
                                } else {
                                    copy.classList.remove('--active');
                                }
                            } catch (err) {
                                console.error('Failed to copy: ', err);
                            }
                        })
                    }
                    this.submitButton.disabled = false;
                    this.spinner.style.display = 'none';
                    this.close = document.querySelectorAll('.js-form-close');
                    if (this.close) {
                        this.close.forEach(button => {
                            button.addEventListener('click', () => {
                                this.form.classList.remove('done');
                                this.messageText.innerHTML = '';
                                document.body.classList.remove('has-modal-open');
                                this.clearForm();
                            });
                        })
                    }
                });
        }
    }

    /**
     * Makes a string of parameters to send in request to a server.
     * @param {Object} params
     * @returns {string}
     */
    encodeParams(params) {

        return Object.entries(params).map(param => param.map(encodeURIComponent).join("=")).join("&");
    }

    addListeners() {
        this.form.querySelectorAll('.js-form-check').forEach((element, ind) => {
            element.addEventListener('change', (event) => {
                this.validate(event.target);
                this.checkFormIsReady();
            });
        });

        this.form.querySelectorAll('.form-select').forEach(element => {
            element.addEventListener('change', (event) => {
                this.validateInputLength(event.target);
                this.checkFormIsReady();
            });
        });


        this.format.addEventListener('change', (e) => {
            if (e.target.value === 'Онлайн') {
                this.disableCluster();
            } else {
                this.enableCluster();
            }
        });

        this.experience.addEventListener('change', (e) => {
            if (e.target.value === 'Студент') {
                this.enableUniversity();
                this.enableLearningProgram();
            } else {
                this.disableUniversity();
                this.disableLearningProgram();
            }

            if (e.target.value === 'Преподаватель' || e.target.value === 'Опытный инженер') {
                this.disableInPerson();
                this.disableCluster();
            } else {
                this.clearFormat();
                this.enableCluster();
                this.clearInPerson();
            }
        });
    }

    addFirstActionListener() {
        let triggered = false;
        let self = this;

        function handleEvent(e) {
            if (e.target.matches("input, select, textarea")) {
                try {
                    window.YadroWebMetrics.track({"event_category":"reg_form", "event_action":"form_stage", "event_label":"form_start"});
                } catch (ex) {
                    console.error(ex);
                }
                if (!triggered) {
                    triggered = true;
                    self.form.removeEventListener("input", handleEvent);
                    self.form.removeEventListener("change", handleEvent);
                }
            }
        }

        this.form.addEventListener("input", handleEvent);
        this.form.addEventListener("change", handleEvent);
    }

    disableCluster() {
        this.cluster.value = '';
        this.cluster.setAttribute('disabled', '');
        this.cluster.nextElementSibling.textContent = '';
    }

    enableCluster() {
        this.cluster.removeAttribute('disabled');
    }

    disableUniversity() {
        this.university.setAttribute('disabled', '');
        this.university.removeAttribute('required');
        this.university.value = '';
        this.university.nextElementSibling.textContent = '';
    }

    disableLearningProgram() {
        this.learningProgram.value = '';
        this.learningProgram.setAttribute('disabled', '');
        this.university.removeAttribute('required');
        this.learningProgram.nextElementSibling.textContent = '';
    }

    enableUniversity() {
        this.university.removeAttribute('disabled');
        this.university.setAttribute('required', '');
    }

    enableLearningProgram() {
        this.learningProgram.removeAttribute('disabled');
        this.learningProgram.setAttribute('required', '');
    }

    disableInPerson() {
        this.format.value = 'Онлайн';
        this.formatInPerson.setAttribute('disabled', '');
        this.formatInPerson.style.display = 'none';
        this.format.nextElementSibling.textContent = '';
    }

    clearInPerson() {
        this.format.value = '';
        this.format.nextElementSibling.textContent = '';
    }

    enableInPerson() {
        this.formatInPerson.removeAttribute('disabled');
        this.formatInPerson.style.display = '';
    }

    forceInPerson() {
        this.format.value = 'Очный';
        this.format.setAttribute('disabled', '');
        this.format.nextElementSibling.textContent = '';
    }

    forceOnline() {
        this.format.value = 'Онлайн';
        //this.format.setAttribute('disabled', '');
        this.format.nextElementSibling.textContent = '';
    }

    clearFormat() {
        this.enableInPerson();
        this.format.removeAttribute('disabled');
    }

    clearForm() {
        let newForm = this.formTemplate.cloneNode(true);
        this.form.after(newForm);
        this.form.remove();
        this.form = newForm;
        this.prepareForm();
    }
}

export default ApplicationForm;